import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  token: null,
  adminToken: null,
  partnerToken: null,
  prospectAppId: null,
  appId: null,
  partnerId: null,
  productId: null,
  productType: null,
  merchantId: null,
  isPartner: null,
  adminId: null,
  roleId: null,
  utms: null,
  urlSegment: null,
};

const tokenSlice = createSlice({
  name: "token",
  initialState,
  reducers: {
    setToken: (state, action) => {
      state.token = action.payload;
    },
    setAdminToken: (state, action) => {
      state.adminToken = action.payload;
    },
    setPartnerToken: (state, action) => {
      state.partnerToken = action.payload;
    },
    setProspectAppId: (state, action) => {
      state.prospectAppId = action.payload;
    },
    setAppId: (state, action) => {
      state.appId = action.payload;
    },
    setPartnerId: (state, action) => {
      state.partnerId = action.payload;
    },
    setProductId: (state, action) => {
      state.productId = action.payload;
    },
    setProductType: (state, action) => {
      state.productType = action.payload;
    },
    setMerchantId: (state, action) => {
      state.merchantId = action.payload;
    },
    setIsPartner: (state, action) => {
      state.isPartner = action.payload;
    },
    setAdminId: (state, action) => {
      state.adminId = action.payload;
    },
    setRoleId: (state, action) => {
      state.roleId = action.payload;
    },
    setUTMs: (state, action) => {
      state.utms = action.payload;
    },
    setUrlSegment: (state, action) => {
      state.urlSegment = action.payload;
    },
  },
});

export const { setToken, setAdminToken, setPartnerToken, setProspectAppId, setAppId, setPartnerId, setProductId, setProductType, setMerchantId, setIsPartner, setAdminId, setRoleId, setUTMs, setUrlSegment } = tokenSlice.actions;
export default tokenSlice.reducer;